<template lang="pug">
.folder-container(
  @click="$emit('click')"
  @drop="$emit('drop')"
  @dragover.prevent="$emit('dragover', $event)"
  @dragenter.prevent="$emit('dragenter', $event)"
  @dragleave="$emit('dragleave', $event)"
  v-bind="$props"
)
  .folder.word-break
    template(v-if="status")
      v-progress-circular.ma-auto(v-if='status === "loading"' indeterminate)
      v-icon.white--text(v-else-if='status === "success"') mdi-check
    slot(v-else)
    .folder-actions(v-if="showActions")
      v-btn.mr-2(@click.stop="$emit('edit')" color="primary" fab x-small)
        v-icon mdi-pencil
      v-btn(@click.stop="$emit('delete')" color="error" fab x-small)
        v-icon mdi-close
  p.caption.ma-2.line-clamp-3 {{ name }}

</template>

<script>
export default {
  props:{
    status:{ type:[String, Boolean], required:false, default: null },
    showActions: { type: Boolean,    required:false, default: false },
    name:{ type:String, required:false, default: 'Папка' },
  },
};
</script>

<style lang="scss">
$size: 100px;
$color: #444;
$active-color: #ebbe37;

.folder-container {
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  min-width: $size;
  max-width: $size;
  margin-right: 20px;
  &.active{
    .folder {
      background: $active-color;
    }
  }
  &:hover{
    cursor: pointer;
    .folder{
      background-color: #f7d672cc;
    }
  }
}

.folder {
  display: flex;
  align-items: center;
  justify-content: center;

  &:before {
    content: '';
    float: left;
    background-color: #fbeca6;
    height: 0.45em;
    width: 3em;
    margin-left: 0.07em;
    margin-bottom: -0.07em;
    border-top-left-radius: 0.1em;
    border-top-right-radius: 0.1em;
    position: absolute;
    left: 0;
    top:-5px;
  }

  position: relative;
  background-color: #f7d672;
  border-radius: 0.1em;
  width: 100%;
  height: 5em;

  &:hover{
    .folder-actions{
      display: flex;
      opacity: 1;
    }
  }

  &-actions{
    transition: all 0.3s;
    opacity: 0;
    position: absolute;
    right: 0;
    top: -10px;
  }
}
</style>
